import { InjectionToken, Provider } from '@angular/core';

export interface VersionWatcherOptions {
  checkInterval: number;
}

export const VERSION_WATCHER_OPTIONS =
  new InjectionToken<VersionWatcherOptions>('VERSION_WATCHER_OPTIONS');

const DEFAULT_VERSION_WATCHER_OPTIONS: VersionWatcherOptions = {
  checkInterval: 6 * 60 * 60 * 1000, // 6 hours
};

export function provideVersionWatcherOptions(
  options?: VersionWatcherOptions
): Provider {
  return {
    provide: VERSION_WATCHER_OPTIONS,
    useValue: { ...DEFAULT_VERSION_WATCHER_OPTIONS, ...(options ?? {}) },
  };
}
